import { http } from "../client";
import axios from "axios";
export var ActivateDeviceFailureVariant;
(function (ActivateDeviceFailureVariant) {
    ActivateDeviceFailureVariant[ActivateDeviceFailureVariant["BadRequest"] = 0] = "BadRequest";
    ActivateDeviceFailureVariant[ActivateDeviceFailureVariant["Forbidden"] = 1] = "Forbidden";
    ActivateDeviceFailureVariant[ActivateDeviceFailureVariant["NotFound"] = 2] = "NotFound";
})(ActivateDeviceFailureVariant || (ActivateDeviceFailureVariant = {}));
var mapErrorToFailureVariant = function (error) {
    var _a;
    if (axios.isAxiosError(error)) {
        var status = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status;
        if (status === 400)
            return ActivateDeviceFailureVariant.BadRequest;
        if (status === 403)
            return ActivateDeviceFailureVariant.Forbidden;
        if (status === 404)
            return ActivateDeviceFailureVariant.NotFound;
    }
    return null;
};
export var activateDevice = function (key) {
    return http.api
        .post("devices/activate", {
        activation_key: key,
    })
        .then(function (response) { return response.data; })
        .then(function (data) { return ({ id: data.device_id }); })
        .catch(function (error) { return Promise.reject(mapErrorToFailureVariant(error)); });
};
